import { SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC } from 'containers/CustomizedAutoSync/constants'

import {
  AS_GD_ASYNC,
  AS_O365_ASYNC,
  DATA_REQUEST_ASYNC as MAILBOXES_INFO_ASYNC,
} from '../constants'

import { AUTO_SYNC_DISABLE_ASYNC, GD_ADMIN_EMAIL_CHANGE } from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
    asSuccess: false,
    asLoader: false,
    activeSyncType: null,
    activeSyncTypeLoader: false,
    gdAdminEmail: '',
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case GD_ADMIN_EMAIL_CHANGE:
        return { ...state, gdAdminEmail: action.payload.val }
      case SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC.INITIATE:
        return { ...state, asLoader: true }
      case SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC.SUCCESS:
        return { ...state, asSuccess: true, asLoader: false }
      case AS_O365_ASYNC.INITIATE:
      case AS_GD_ASYNC.INITIATE:
        return { ...state, asLoader: true }
      case AS_O365_ASYNC.SUCCESS:
        return {
          ...state,
          asSuccess: true,
          asLoader: false,
          activeSyncType: 2,
        }
      case AS_GD_ASYNC.SUCCESS:
        return {
          ...state,
          asSuccess: true,
          asLoader: false,
          activeSyncType: 3,
        }
      case AS_O365_ASYNC.ERROR:
      case AS_GD_ASYNC.ERROR:
        return {
          ...state,
          asSuccess: false,
          asLoader: false,
        }
      case AS_O365_ASYNC.CANCEL:
      case AS_GD_ASYNC.CANCEL:
        return { ...state, asLoader: false }
      case MAILBOXES_INFO_ASYNC.SUCCESS:
        return {
          ...state,
          activeSyncType: action.payload.data.activeType,
          gdAdminEmail: action.payload.data.gdAdminEmail,
        }
      case AUTO_SYNC_DISABLE_ASYNC.INITIATE:
        return {
          ...state,
          activeSyncTypeLoader: true,
        }
      case AUTO_SYNC_DISABLE_ASYNC.SUCCESS:
        return {
          ...state,
          asSuccess: false,
          activeSyncType: null,
          activeSyncTypeLoader: false,
        }
      case AUTO_SYNC_DISABLE_ASYNC.ERROR:
      case AUTO_SYNC_DISABLE_ASYNC.CANCEL:
        return {
          ...state,
          activeSyncTypeLoader: false,
        }
      default:
        return state
    }
  }
}
